import './RankingHeader.css';

import React from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';
import moment from 'moment';

import { RankingPropsTypes } from '@models/Ranking';
import Metas from '@views/Metas';
import InviteParticipants from '@views/InviteParticipants';

import Link from 'redux-first-router-link';
import { LeftOutlined, UserAddOutlined } from '@ant-design/icons';
import { Modal } from 'antd';
import Button from '@views/Button';

export const LeaveRankingModal = ({
  visible,
  onOk,
  onCancel,
  isOwner,
  name,
}) => (
  <Modal
    title={isOwner ? '¿Eliminar Torneo?' : 'Salir del Torneo?'}
    visible={visible}
    onOk={onOk}
    onCancel={onCancel}
    cancelText="Cancelar"
    okText={isOwner ? 'Eliminar' : 'Salir'}
    destroyOnClose
    okButtonProps={{ className: 'mbutton mbutton-danger' }}
    cancelButtonProps={{ className: 'mbutton mbutton-secondary' }}
  >
    {isOwner ? (
      <p>
        Estás a punto de eliminar el torneo <b>{name}</b>. Ninguno de sus
        miembros podrá acceder y no se podrá recuperar. ¿Confirmas esta acción?
      </p>
    ) : (
      <p>
        Estás a punto de dejar el torneo <b>{name}</b>. ¿Confirmas esta acción?
      </p>
    )}
  </Modal>
);

export const RankingHeader = ({
  _id,
  name,
  isOwner,
  isPartnerGroup,
  onAddParticipants,
  onEditName,
  onRemoveRanking,
  createdAt,
  owner,
}) => {
  const [confirmVisible, setConfirmVisible] = React.useState(false);
  const showLeave = !isPartnerGroup;
  const showInvite = isOwner && !isPartnerGroup;
  const showDelete = isOwner;
  const showActions = showLeave || showInvite || showDelete;

  const handleRemove = () =>
    Promise.resolve(onRemoveRanking()).then(() => setConfirmVisible(false));

  return (
    <div className="ranking-details-header">
      <Metas
        title={`${name}, un torneo del Prode Mundial 2026`}
        path={`rankings/${_id}`}
        mobileNarrow
      />
      <div className="title-container">
        <Link to={['mis-torneos']}>
          <LeftOutlined size="big" />
        </Link>
        <h3>{name}</h3>
        <div className="break-mobile"></div>
        <div className="actions">
          {showActions ? (
            <>
              <LeaveRankingModal
                visible={confirmVisible}
                isOwner={isOwner}
                name={name}
                onOk={handleRemove}
                onCancel={() => setConfirmVisible(false)}
              />
              {showInvite ? (
                <Button
                  onClick={onAddParticipants}
                  type="secondary"
                  icon={<UserAddOutlined />}
                  style={{
                    marginRight: '10px',
                    height: 44,
                    width: 44,
                    borderRadius: '50%',
                    padding: 0,
                  }}
                />
              ) : null}
              {showDelete ? (
                <Button type="danger" onClick={() => setConfirmVisible(true)}>
                  Eliminar torneo
                </Button>
              ) : null}
              {showLeave && !isOwner ? (
                <Button type="danger" onClick={() => setConfirmVisible(true)}>
                  Salir del torneo
                </Button>
              ) : null}
            </>
          ) : null}
        </div>
      </div>
      <div className="created-by-container">
        {createdAt && owner ? (
          <p className="created-by">
            Creado el {moment(createdAt).format('DD/MM/YYYY')} por{' '}
            {owner.username}
          </p>
        ) : null}
      </div>
      {!isPartnerGroup ? <InviteParticipants /> : null}
    </div>
  );
};

RankingHeader.displayName = 'RankingHeader';
RankingHeader.propTypes = {
  ...RankingPropsTypes,
  onAddParticipants: PropTypes.func,
  onEditName: PropTypes.func,
  onRemoveRanking: PropTypes.func,
};

RankingHeader.defaultProps = {
  name: '',
  isPartnerGroup: false,
  onAddParticipants: noop,
  onEditName: noop,
  onRemoveRanking: noop,
};

export default RankingHeader;
